












































































import BaseComponent from '@/components/base-component.vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as service from '@/services/patients';

@Component({
  components: {},
  directives: {}
})
export default class PatientMergeSet extends BaseComponent {
  @Prop()
  patientOrigin: any;

  @Prop()
  idPatientMerge: any;

  patientMerge: any = {};

  patientResult: any = {};

  @Watch('idPatientMerge', { immediate: true })
  onIdPatientMergeChange(val) {
    this.loader.start('Carregando item...');
    service.getPatientDetails(this.idPatientMerge).subscribe(
      (data) => {
        this.patientMerge = data;
        this.setDefaultPatientResult();
      },
      () => {
        this.loader.stop();
        this.toast.show('Ocorreu um erro ao carregar o item', 'error');
      }
    );
  }

  setDefaultPatientResult() {
    this.loader.start('Preparando...');
    service.getIdPatientLatest([this.idPatientMerge, this.patientOrigin.id]).subscribe(res => {
      if (this.patientMerge.id == res) {
        this.patientResult = Object.assign({}, this.patientMerge);
      } else {
        this.patientResult = Object.assign({}, this.patientOrigin);
      }
      this.onPatientResultChange(this.patientResult);
      this.loader.stop();
    }, error => {
      this.loader.stop();
      this.toast.show('Ocorreu um erro ao carregar o item', 'error');
    });
  }

  buildItemsComboPatientProp(idProp, nameProp) {
    let items = [];
    if (this.patientOrigin[idProp]) {
      items.push({ id: this.patientOrigin[idProp], name: this.patientOrigin[nameProp] });
    }
    if (this.patientMerge[idProp]) {
      items.push({ id: this.patientMerge[idProp], name: this.patientMerge[nameProp] });
    }
    return items;
  }

  @Watch('patientResult', { deep: true })
  onPatientResultChange(val) {
    let res: any = {};
    res.ids = [this.patientOrigin.id, this.idPatientMerge];
    res.nome = val.nome;
    res.nascimento = val.nascimento;
    res.peso = val.peso;
    res.sexo = val.sexo;
    res.same = val.same;
    res.termo = val.termo;
    res.ativo = val.ativo;

    res.unidades = [];
    res.unidadesConcat = '';
    this.patientOrigin.unidades.forEach((u) => res.unidades.push(u.nome));
    this.patientMerge.unidades.forEach((u) => res.unidades.push(u.nome));
    res.unidades = [...new Set(res.unidades)];
    for (let i = 0; i < res.unidades.length; i++) {
      if (i > 0) {
        if (i + 1 == res.unidades.length) {
          res.unidadesConcat += ' e ';
        } else {
          res.unidadesConcat += ', ';
        }
      }
      res.unidadesConcat += res.unidades[i];
    }

    this.$emit('input', res);
  }
}
